/**
 * @function Tooltip
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * 
 * Erstellt einen tooltip
 * Basiert auf dem Angular-Strap Popover
 * 
 */

angular.module('v3sWbtPlayerApp').directive('v3sTooltip', ["$popover", "$tooltip", "v3sContentMediaPath", function ($popover, $tooltip, v3sContentMediaPath) {
    return {
        restrict: 'E',
        replace: false,
        scope: {
            v3sTop: '@',
            v3sLeft: '@'
        },
        controller: ["$scope", "$element", "$attrs", function ($scope, $element, $attrs) {
        }],
        link: function (scope, element, attrs) {
            var data = element.find('v3s-data');
            var tooltipContent = "";

            if (attrs.v3sFile != "") {
                var imgFileSrc = v3sContentMediaPath + attrs.v3sFile;
                tooltipContent += '<img src="' + imgFileSrc + '"></img>';
            }

            if (!!data.html()) {
                tooltipContent += '<span>' + data.html() + '</span>';
            }
                
            if (!!tooltipContent) {
                tooltipContent = '<div class="v3s-tooltip-content">' + tooltipContent + '</div>';
                $popover(element.parent(), { content: tooltipContent, html: true, placement: 'auto', container: "v3s-document", viewport: '#page-view', trigger: 'hover' });
            }
            
        }
    }
}]);
